// extracted by mini-css-extract-plugin
export default {"article":"styles_article__jDbL6","action":"styles_action__rQgqJ","icon":"styles_icon__Q2NPC","description":"styles_description__8Gmn9"};